import Vue from 'vue';
import Notifications from 'vue-notification';
import Svgicon from 'vue-svgicon';
import Modal from './plugins/modal';
import Authorization from './plugins/authorization';
import './icons';

Vue.use(Notifications);
Vue.use(Svgicon);
Vue.use(Modal);
Vue.use(Authorization);
